import { render, staticRenderFns } from "./Contents.vue?vue&type=template&id=177e924c&scoped=true"
import script from "./Contents.vue?vue&type=script&lang=js"
export * from "./Contents.vue?vue&type=script&lang=js"
import style0 from "./Contents.vue?vue&type=style&index=0&id=177e924c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "177e924c",
  null
  
)

export default component.exports